import React, { useState } from "react";
import { Button, Carousel } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const HeroSection = ({ slides, isMobile }) => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleSlideButtonClick = (path) => navigate(path);

  const carouselSettings = {
    autoplay: true,
    autoplaySpeed: 2300,
    dots: true,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    ...(isMobile ? {
      slidesToShow: 1,
    } : {
      centerMode: true,
      slidesToShow: 1,
      centerPadding: "20%",
    })
  };

  return (
    <>
      <Carousel {...carouselSettings}>
        {slides.map((item, i) => (
          <SlideItem 
            key={i} 
            item={item} 
            isMobile={isMobile} 
            onButtonClick={handleSlideButtonClick}
            isActive={i === currentSlide}
          />
        ))}
      </Carousel>
      <div style={{ height: isMobile ? "20px" : "40px" }} />
    </>
  );
};

const SlideItem = ({ item, isMobile, onButtonClick, isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          height: isMobile ? "300px" : "480px",
          overflow: "hidden",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            width: isMobile ? "100%" : isActive ? "98%" : "90%",
            height: isMobile ? "100%" : isActive ? "100%" : "90%",
            transition: "all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            transform: isActive 
              ? (isHovered ? "scale(1.02)" : "scale(1)")
              : "scale(0.95)",
            filter: isActive 
              ? "none" 
              : "brightness(0.7) blur(1px)",
            opacity: isActive ? 1 : 0.8,
          }}
        >
          <img
            src={item.img}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: isMobile ? "0px" : "12px",
              transition: "all 0.5s ease",
              transform: isHovered && isActive ? "scale(1.1)" : "scale(1)",
              ...(!isMobile && {
                WebkitMaskImage: "none",
                maskImage: "none",
              }),
            }}
            alt={item.sport}
          />

          {/* Gradient Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: isActive 
                ? "linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)"
                : "linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.3) 100%)",
              borderRadius: isMobile ? "0px" : "12px",
              transition: "all 0.3s ease",
            }}
          />

          {/* Explore Button - Only show on active slide */}
          {isActive && (
            <div
              style={{
                position: "absolute",
                bottom: isMobile ? "20px" : "35px",
                left: isMobile ? "20px" : "35px",
                zIndex: 2,
                transform: isHovered ? "translateY(-5px)" : "translateY(0)",
                transition: "transform 0.3s ease",
              }}
            >
              <Button
                size={isMobile ? "middle" : "large"}
                style={{
                  backgroundColor: "transparent",
                  borderColor: "#FFFFFF",
                  color: "#FFFFFF",
                  fontWeight: 600,
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  gap: isMobile ? "6px" : "8px",
                  padding: isMobile ? "0 16px" : "0 28px",
                  fontSize: isMobile ? "12px" : "14px",
                  height: isMobile ? "32px" : "40px",
                  transition: "all 0.3s ease",
                  transform: isHovered ? "scale(1.05)" : "scale(1)",
                  boxShadow: isHovered ? "0 8px 20px rgba(0,0,0,0.3)" : "0 4px 12px rgba(0,0,0,0.2)",
                }}
                onClick={() => onButtonClick(item.path)}
              >
                Explore Now <ArrowRightOutlined />
              </Button>
            </div>
          )}

          {/* Hover Overlay Effect */}
          {isActive && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.1) 100%)",
                opacity: isHovered ? 1 : 0,
                transition: "opacity 0.3s ease",
                borderRadius: isMobile ? "0px" : "12px",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;